module.exports = "uniform float radiusX;\nuniform float radiusZ;\nuniform float size;\nuniform float scale;\nuniform float height;\nuniform float elapsedTime;\nuniform float speedH;\nuniform float speedV;\nvoid main() {\n\tvec3 pos = position;\n\tpos.x += cos((elapsedTime + position.z) * 0.25 * speedH) * radiusX;\n\tpos.y = mod(pos.y - elapsedTime * speedV, height);\n\tpos.z += sin((elapsedTime + position.x) * 0.25 * speedH) * radiusZ;\n\tvec4 mvPosition = modelViewMatrix * vec4( pos, 1.0 );\n\tgl_PointSize = size * ( scale / length( mvPosition.xyz ) );\n\tgl_Position = projectionMatrix * mvPosition;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shader/snow.vert
// module id = 5
// module chunks = 0